<template>
  <div>
    <!-- 抽屉 -->
    <el-drawer
      :append-to-body="true"
      class="drawer"
      title="请选择权按钮"
      :visible.sync="drawerShow"
      :before-close="handleClose">
      <div class="container">
        <el-row class="screen" :span="24">
          <el-col :span="16">
            <el-input placeholder="请输入设备名称" v-model.trim="deviceName" @keyup.13.native="drawerHandlerKeyUp" class="inp"  >
              <el-button slot="append" icon="el-icon-search" @click="drawerDemand"></el-button>
            </el-input>
          </el-col>
        </el-row>
         <el-table
          ref="multipleTable"
          :data="versionTableData"
          :row-key="getRowKeys"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          @select='onTableSelect'
          @select-all="handleAllChange"
          @selection-change="handleSelectionChange">
          <el-table-column
          :reserve-selection="true"
          :selectable="selectable"
          type="selection">
          </el-table-column>
          <el-table-column
            prop="deviceName"
            label="DeviceName"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="productKey"
            label="ProductKey"
            >
          </el-table-column>
          <el-table-column
            prop="isEnable"
            label="设备状态"
            >
            <template slot-scope="scope">
              {{scope.row.isEnable === false? '禁用': '启用'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="nodeType"
            label=节点类型
            >
            <template slot-scope="scope">
               {{scope.row.nodeType === 0 ? '直连设备' : scope.row.nodeType === 1 ? '网关子设备' : '网关设备'}}
            </template>
          </el-table-column>
        </el-table>
         <!-- 分页管理 -->
        <Paging :total="total" @changePage="changePage"/>
      </div>
      <div class="drawer-footer">
      <div class="drawer-btn">
          <el-button
          type="primary"
          @click="confirm"
          >
            确定
          </el-button>
          <el-button @click="cancel" >取消</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Paging from '@/components/paging'
import { deviceList } from '@/api/deviceManagement'
export default {
  components: {
    Paging
  },
  props: {
    drawerFlag: {
      type: Boolean,
      default: false
    },
    accessData: {
      type: Array
    },
    productKey: {
      type: String
    }
  },
  watch: {
    multipleSelection: {
      handler (val) {
        console.log('watch', val)
      }
    }
  },
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      drawerShow: false,
      deviceName: '', // 设备名称
      versionTableData: [],
      multipleSelection: [], // 选择框选的数量
      keysArr: []
    }
  },
  created () {
    console.log(this.accessData)
    this.drawerShow = this.drawerFlag
    this.getRoleList()
  },
  mounted () {
  },
  methods: {
    // 获取权限列表
    getRoleList () {
      this.keysArr = this.accessData.map(v => v.deviceName)
      const params = {
        deviceName: this.deviceName,
        productKey: this.productKey,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      deviceList(params).then((res) => {
        console.log(res)
        const resData = res.data.data
        console.log(resData)
        this.versionTableData = resData.data
        if (resData.total <= 5) this.listLoading = true
        this.total = resData.total
        this.$nextTick(() => {
          if (this.versionTableData.length && this.versionTableData.length > 0) {
            this.versionTableData.forEach(row => {
              if (this.keysArr.includes(row.deviceName)) {
                this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            })
          }
        })
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？', '提示', {
        closeOnClickModal: false
      })
        .then(_ => {
          this.$emit('closeDrawer')
        })
        .catch(_ => {})
        .finally(_ => {
          // this.$parent.focusStatus = true
        })
    },
    // 抽屉搜索功能
    drawerHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.drawerDemand()
      }
    },
    // 搜索
    drawerDemand () {
      this.listQuery.page = 1
      this.getRoleList()
    },
    // 分页管理
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getRoleList()
    },
    // 改变页码
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getRoleList()
    },
    getRowKeys (row) {
      return row.deviceName // id为列表数据的唯一标识
    },
    handleAllChange (selecteds, row) {
      // selecteds length > 0 则是全选,为空则为反选
      console.log('当前选中的', selecteds, row)
      if (selecteds.length === 0) {
        console.log('selecteds', selecteds)
        console.log('multipleSelection', this.multipleSelection)
        this.versionTableData.forEach(item => {
          this.keysArr.forEach((id, index) => {
            if (id === item.deviceName) {
              this.keysArr.splice(index, 1)
            }
          })
        })
        // 反选框复选时 将accessData数据清除
        /* this.versionTableData.forEach(item => {
          console.log('1', item)
          this.accessData.forEach((ele, index) => {
            if (ele.deviceName === item.deviceName) {
              this.accessData.splice(index, 1)
            }
          })
        }) */
        /* this.versionTableData.forEach(item => {
          this.multipleSelection.forEach((id, index) => {
            if (id.deviceName === item.deviceName) {
              this.multipleSelection.splice(index, 1)
            }
          })
        }) */
        console.log('执行完毕', this.accessData)
      } else {
        const arrData = []
        // 对accessData进行拷贝
        const cloneArr = JSON.parse(JSON.stringify(this.accessData))
        console.log(cloneArr)
        selecteds.forEach(item => {
          if (!this.keysArr.includes(item.deviceName)) {
            console.log(0, item)
            this.keysArr.push(item.deviceName)
          } else {
            console.log(1, item)
            console.log(this.keysArr)
            // keysArr中存在的时候 deviceId时，分页处理，删除accessData多余部分
            this.keysArr.splice(item.deviceName)
            this.multipleSelection.forEach((ele, index) => {
              const objData = {}
              objData.deviceName = ele.deviceName
              objData.productKey = ele.productKey
              arrData.push(objData)
            })
            this.accessData.splice(0, this.accessData.length)
            this.accessData.push(arrData)
            arrData.length = 0
            console.log(this.keysArr)
            console.log(this.accessData)
          }
        })
      }
    },
    onTableSelect (rows, row) {
      console.log(row)
      const selected = rows.length && rows.indexOf(row) !== -1 // true就是选中，0或者false是取消选中
      if (!selected) { // 为false时将id截取出来
        for (let index = 0; index < this.keysArr.length; index++) {
          if (this.keysArr[index] === row.deviceName) {
            this.keysArr.splice(index, 1)
          }
        }
        // 将数据容器数据删除
        this.accessData.forEach((e, index) => {
          if (e.deviceName === row.deviceName) {
            console.log('触发')
            this.accessData.splice(index, 1)
          }
        })
      }
    },
    // table栏val选择的时间
    handleSelectionChange (val) {
      console.log('选择的', val)
      this.multipleSelection = val
    },
    confirm () {
      console.log('keysArr', this.keysArr)
      console.log('multipleSelection', this.multipleSelection)
      const sendData = []
      this.multipleSelection.forEach((ele) => {
        sendData.push({
          deviceName: ele.deviceName,
          productKey: ele.productKey
        })
      })
      const keysData = []
      this.keysArr.forEach((res) => {
        this.accessData.map((ele) => {
          if (ele.deviceName === res) {
            keysData.push({
              deviceName: ele.deviceName,
              productKey: ele.productKey
            })
          }
        })
      })
      const arr = sendData.concat(keysData)
      console.log(arr)
      const result = []
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].deviceName]) {
          result.push(arr[i])
          obj[arr[i].deviceName] = true
        }
      }
      console.log('传过去的值', result)
      // 截断一下内容为undefined
      result.forEach((e, index) => {
        if (!e.deviceName) result.splice(index, 1)
      })
      this.$emit('getData', result)
    },
    cancel () {
      this.handleClose()
    },
    // 禁选设备状态为DisEnable的行
    selectable (row) {
      if (row.isEnable === false) {
        return false
      } else {
        return true
      }
    },
    // 分页功能
    changePage (val) {
      this.listQuery = val
      this.getRoleList()
    }
  }
}
</script>

<style lang='less' scoped>
.drawer{
    /deep/ .el-drawer__header{
      line-height: 60px !important;
      font-size: 18px !important;
      height: 60px !important;
      border-bottom: 1px solid #efefef !important;
      padding: 0 24px !important;
      margin-bottom: 0 !important;
    }
    /deep/ .el-drawer__body{
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      .container{
        margin-bottom: 64px;
        padding: 16px 24px 0 24px !important;
        border-top: 1px solid #ececec;
        .screen{
          display: flex;
          margin-bottom: 20px;
          /deep/ .el-input{
            margin-left: 0;
            width: 90%;
          }
        }
        /deep/ .el-table::before{
          background: white;
        }
        /deep/ .el-table th>.cell:first-child{
          padding: 0 14px
        }
        /* .cell:first-child{

        } */
      }
      .drawer-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ececec;
        margin-top: 10px;
        padding: 0 24px ;
        height:64px;
        i{
          color: #409eff;
          font-style: normal;
        }
      }
    }
    /deep/ :focus {
      outline: 0;
    }
  }
</style>
